// eslint-disable-next-line
import type { MapDiagnosticContext } from '@m43/bridge-interface';
import type { MapView } from '../constructors';

let fatalErrorCount = 0;
let contextLossCount = 0;
let contextRestoreCount = 0;
let mapCreatedTimestampMs: number | null = null;

export function incrementFatalErrorCount(): void {
    fatalErrorCount++;
}

export function incrementContextLossCount(): void {
    contextLossCount++;
}

export function incrementContextRestoreCount(): void {
    contextRestoreCount++;
}

export function markMapCreated(): void {
    mapCreatedTimestampMs = Date.now();
}

export function resetMapCounters(): void {
    fatalErrorCount = 0;
    contextLossCount = 0;
    contextRestoreCount = 0;
    mapCreatedTimestampMs = null;
}

export function getMapDiagnosticContext(
    mapView: MapView | undefined,
    mapRef: React.MutableRefObject<HTMLDivElement | null>,
    isEmbeddedMap: boolean
): MapDiagnosticContext {
    let layerCount = 0;
    let layers: Array<{ layerKey: string; graphicsCount?: number }> = [];

    if (mapView?.map?.layers) {
        const allLayers = mapView.map.layers.toArray();
        layerCount = allLayers.length;
        layers = allLayers.map((layer) => {
            const entry: { layerKey: string; graphicsCount?: number } = {
                layerKey: layer.id ?? 'unknown',
            };
            // Try multiple access patterns:
            // - GraphicsLayer: has `graphics` Collection with `length`
            // - FeatureLayer: has `source` Collection with `length` (in-memory features)
            const graphics = ((layer as unknown) as { graphics?: { length?: number } }).graphics;
            const source = ((layer as unknown) as { source?: { length?: number } }).source;
            const collection = graphics ?? source;
            if (collection && typeof collection.length === 'number') {
                entry.graphicsCount = collection.length;
            }
            return entry;
        });
    }

    const canvasCount = mapRef.current?.querySelectorAll('canvas')?.length ?? 0;

    const readyState = mapView
        ? ((mapView as unknown) as { readyState?: string }).readyState
        : undefined;

    const result: MapDiagnosticContext = {
        fatalErrorCount,
        contextLossCount,
        contextRestoreCount,
        isEmbeddedMap,
        layerCount,
        layers,
        canvasCount,
    };

    if (mapCreatedTimestampMs != null) {
        result.mapAgeSeconds = Math.round((Date.now() - mapCreatedTimestampMs) / 1000);
    }
    if (mapView?.zoom != null) {
        result.zoom = mapView.zoom;
    }
    if (readyState != null) {
        result.readyState = readyState;
    }

    return result;
}
